import React from 'react'
import Navbar from './../../components/Navbar';
import IndustriesImageContainer from './../../components/IndustriesImageContainer';
import Footer from '../../components/Footer';
import karibia from "../../assets/images/contents/case-study-document-security.png"
import filter_color from "../../assets/images/design/colorFilter.svg"
import CaseStudyForm from './CaseStudyForm';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../../redux/language/selector';
import { useTranslation } from 'react-i18next';

const CaseStudyKaribia = () => {
  const language = useSelector(selectLanguage)

  const {t} = useTranslation()

  return (
    <div className='karibia bg-primary'>
      <div className='color-filter-left' style={{ top: "35%" }} >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <Navbar />
      <div className='karibia-content container pt-150'>
        <div className='row'>
          <div className="col-lg-w--500">
            {language === "en"
            ?
            <p className='text-white font-40 font-weight-medium'>Download Karibia <span className='text-gradient'>Case Study</span></p>
            :
            <p className='text-white font-40 font-weight-medium pr-lg-100'>Tải xuống <span className='text-gradient'>nghiên cứu trường hợp</span> của Karibia </p>
            }
            <div className="karibia-card mt-40">
              <div className='karibia-card_image'>
                <img src={karibia} alt="" className='img-responsive' />
              </div>
            </div>

            <div className='col-xs-12 karibia-card-info mt-40 flex-xl'>
              <div className="col-xl-3 col-xs-12 karibia-card-info_item">
                <p className='font-18 text-white'>{t('karibia.client')}</p>
                <p className='text-gray font-14'>{t('karibia.karibia-technology-solutions-limited')}</p>
              </div>
              <div className="col-xl-3 col-xs-12 karibia-card-info_item">
                <p className='font-18 text-white'>{t('karibia.category')}</p>
                <p className='text-gray font-14'>{t('karibia.document-security')}</p>
              </div>
              <div className="col-xl-3 col-xs-12 karibia-card-info_item">
                <p className='font-18 text-white'>{t('karibia.date')}</p>
                <p className='text-gray font-14'>_</p>
              </div>
              <div className="col-xl-3 col-xs-12 karibia-card-info_item">
                <p className='font-18 text-white'>{t('karibia.status')}</p>
                <p className='text-gray font-14'>_</p>
              </div>
            </div>

            <div className='col-xs-12'>
              <div className='row'>
                <p className='text-gradient font-40 font-weight-medium pt-40'>{t('karibia.title-1')}</p>
                {language === "en"
                ?
                <p className='text-gray pt-20'>Karibia Technology Solutions Limited, based out of Nairobi, Kenya specializes in a variety of speed governor, tracking & logistics services. <span className='font-weight-semi-bold'>With a significantly higher rate of 30 to 50 such fake certificates for loan disbursements, their business from banks was shrinking</span>. This is when they learned about Qrypto and started using Qrypto secure QR Code solutions for business.</p>
                :
                <p className='text-gray pt-20'>Karibia Technology Solutions Limited, có trụ sở tại Nairobi, Kenya chuyên về các dịch vụ điều chỉnh tốc độ, theo dõi và hậu cần. <span className='font-weight-semi-bold'>Với tỷ lệ cao hơn đáng kể từ 30 đến 50 giấy chứng nhận giải ngân khoản vay giả như vậy, hoạt động kinh doanh của họ từ các ngân hàng đang bị thu hẹp</span>. Đây là lúc họ biết đến Qrypto và bắt đầu sử dụng giải pháp Mã QR bảo mật Qrypto cho doanh nghiệp.</p>
                }
              </div>

            </div>
          </div>
          <div className="col-xs-12 col-lg-w-500 sticky-form">
            <p className='text-white font-20 font-weight-medium pt-lg-0 pt-50'>{t('karibia.title-2')}</p>
            <CaseStudyForm/>
          </div>
        </div>
      </div>
      <div className='container'>
        <IndustriesImageContainer />
      </div>
      <Footer />
    </div>
  )
}

export default CaseStudyKaribia